module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/light/island-tropical.svg?ff9b871116031f75f5eeaff2a20ca5e2";